// const httpss = 'http://localhost:5002';
const httpss = 'https://dashboard.myu.vn';
// const httpss = 'https://dashboard-api.myu.vn';
// const httpss = 'https://10.33.2.220:5002';
// const httpss = '';
// 10.33.2.220
// 255.255.240.0
// 10.33.0.1
export {httpss};